import {
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { QualityMaturityClient, qualityMaturityApiRef } from './client';

// Unnamed, so its extension id is `api:quality-maturity`.
export const qualityMaturityApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: qualityMaturityApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new QualityMaturityClient({ discoveryApi, fetchApi }),
    }),
});
